// extracted by mini-css-extract-plugin
module.exports = {"modal":"PurchaseReportModal-module--modal--2Z7EB","modalStepTwo":"PurchaseReportModal-module--modalStepTwo--1tuZ7"};